import { createCheckField } from "./checkFieldTypes";
import {
  THREE_PER_PAGE_BAND_INCHES,
  VOUCHER_BANDS,
  roundInches,
} from "./checkGeometry";

const placeField = (fieldType, spec) => {
  const base = createCheckField(fieldType, []);
  return {
    ...base,
    ...spec,
    fieldType,
    xInches: roundInches(spec.xInches),
    yInches: roundInches(spec.yInches),
    widthInches: roundInches(spec.widthInches),
    heightInches: roundInches(spec.heightInches),
  };
};

const checkFaceFields = (bandTop = 0) => [
  placeField("checkDate", {
    xInches: 6.55,
    yInches: bandTop + 0.52,
    widthInches: 1.45,
    heightInches: 0.28,
  }),
  placeField("payeeName", {
    xInches: 1.2,
    yInches: bandTop + 1.12,
    widthInches: 4.9,
    heightInches: 0.32,
    fontBold: true,
  }),
  placeField("amount", {
    xInches: 6.5,
    yInches: bandTop + 1.12,
    widthInches: 1.5,
    heightInches: 0.32,
    fontBold: true,
    textAlign: "right",
  }),
  placeField("amountInWords", {
    xInches: 0.45,
    yInches: bandTop + 1.62,
    widthInches: 6.85,
    heightInches: 0.32,
    overflow: "wrap",
  }),
  placeField("tournamentName", {
    xInches: 0.85,
    yInches: bandTop + 2.72,
    widthInches: 3.4,
    heightInches: 0.28,
  }),
];

const stubFields = (bandTop, prizeLinesHeight) => [
  placeField("checkDate", {
    xInches: 0.45,
    yInches: bandTop + 0.42,
    widthInches: 2.55,
    heightInches: 0.28,
  }),
  placeField("payeeName", {
    xInches: 3.15,
    yInches: bandTop + 0.42,
    widthInches: 4.9,
    heightInches: 0.28,
    fontBold: true,
  }),
  placeField("tournamentName", {
    xInches: 0.45,
    yInches: bandTop + 0.82,
    widthInches: 7.6,
    heightInches: 0.28,
  }),
  placeField("prizeLines", {
    xInches: 0.45,
    yInches: bandTop + 1.22,
    widthInches: 7.6,
    heightInches: prizeLinesHeight,
    fontSizePt: 10,
    overflow: "wrap",
  }),
];

export const defaultCheckFields = (pageLayout = "voucher") => {
  if (pageLayout === "threePerPage") {
    return checkFaceFields(0);
  }
  return [
    ...checkFaceFields(VOUCHER_BANDS[0].topInches),
    ...stubFields(VOUCHER_BANDS[1].topInches, 2.0),
    ...stubFields(VOUCHER_BANDS[2].topInches, 2.45),
  ];
};

export const nextFieldInBand = (fieldType, fields, pageLayout, bandId) => {
  const bands =
    pageLayout === "threePerPage"
      ? [{ id: "check", topInches: 0, heightInches: THREE_PER_PAGE_BAND_INCHES }]
      : VOUCHER_BANDS;
  const band = bands.find((item) => item.id === bandId) || bands[0];
  const inBand = (fields || []).filter(
    (field) =>
      field.yInches >= band.topInches &&
      field.yInches < band.topInches + band.heightInches
  );
  const field = createCheckField(fieldType, inBand);
  const yInches = roundInches(
    Math.min(
      band.topInches + band.heightInches - field.heightInches,
      band.topInches + 0.4 + inBand.length * 0.32
    )
  );
  return {
    ...field,
    yInches: Math.max(band.topInches, yInches),
  };
};
